import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

interface SplashScreenContextValue {
  isVisible: boolean;
  show: () => void;
  hide: () => void;
}

const SplashScreenContext = createContext<SplashScreenContextValue | undefined>(undefined);

export const SplashScreenStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  const show = useCallback(() => setIsVisible(true), []);
  const hide = useCallback(() => setIsVisible(false), []);

  const value = useMemo(() => ({ isVisible, show, hide }), [isVisible, show, hide]);

  return React.createElement(SplashScreenContext.Provider, { value }, children as React.ReactNode);
};

export const useSplashScreenState = () => {
  const ctx = useContext(SplashScreenContext);
  if (!ctx) throw new Error('useSplashScreenState must be used within SplashScreenStateProvider');
  return ctx;
};
